import { PageContent, PageHeader, Space } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { TemplateAbilityGuard } from '@/features/authentication/_components/TemplateAbilityGuard';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';
import { OrganizationTemplateDrawerStateProvider } from '../organization-template/_components/OrganizationTemplateDrawerStateProvider';
import { OrganizationTemplatesPage } from '../organization-template/_pages/OrganizationTemplateListPage';
import { NavigateCreatePageButton } from './_components/NavigateCreatePageButton';
import { NavigateReportPageButton } from './_components/NavigateReportPageButton';
import { GroupsPage } from './groups/_pages/GroupsPage';
import { ProjectGroupPage } from './groups/detail/_pages/ProjectGroupPage';
import { InspectionPage } from './inspection/_pages/InspectionPage';
import { ProjectsPageDynamicLink } from './projects/_components/ProjectsPageDynamicLink';
import { ProjectsProvider } from './projects/_components/ProjectsProvider';
import { ProjectsPage } from './projects/_pages/ProjectsPage';
import { ProjectDetailRoutes } from './projects/detail/routes';
import { CreateProjectPage } from './projects/forms/_pages/CreateProjectPage';
import { ReportProjectPage } from './report/_pages/ReportProjectPage';

export const ProjectsRoutes = () => {
  const { t } = useTranslation();
  return (
    <ProjectsProvider>
      <Routes>
        <Route
          index
          element={
            <>
              <PageHeader
                title={t('projects-page')}
                breadcrumbs={[{ title: t('projects-page') }]}
                buttons={
                  <Space>
                    <NavigateReportPageButton />
                    <ProjectResourceGuard onlyEdit>
                      <Space>
                        <NavigateCreatePageButton text={t('create-project')} />
                      </Space>
                    </ProjectResourceGuard>
                  </Space>
                }
              />
              <PageContent>
                <ProjectsPage />
              </PageContent>
            </>
          }
        />
        <Route
          path="/report"
          element={
            <>
              <PageHeader
                title={t('report-projects-page')}
                breadcrumbs={[
                  { title: <ProjectsPageDynamicLink /> },
                  {
                    title: t('report-projects-page'),
                  },
                ]}
              />
              <PageContent>
                <ReportProjectPage />
              </PageContent>
            </>
          }
        />
        <Route path="/:id/*" element={<ProjectDetailRoutes />} />
        <Route
          path="/new"
          element={
            <ProjectResourceGuard onlyEdit>
              <PageHeader
                title={t('create-project-page')}
                breadcrumbs={[
                  { title: <ProjectsPageDynamicLink /> },
                  { title: t('create-project-page') },
                ]}
              />
              <PageContent>
                <CreateProjectPage />
              </PageContent>
            </ProjectResourceGuard>
          }
        />
        <Route path="/group" element={<GroupsPage />} />
        <Route path="/group/:id" element={<ProjectGroupPage />} />
        <Route path="/inspection" element={<InspectionPage />} />
        <Route
          path="/organization-templates"
          element={
            <TemplateAbilityGuard>
              <OrganizationTemplateDrawerStateProvider>
                <OrganizationTemplatesPage />
              </OrganizationTemplateDrawerStateProvider>
            </TemplateAbilityGuard>
          }
        />
      </Routes>
    </ProjectsProvider>
  );
};
